const Tab = (props: any) => {
  const { title, selected, setSelected, hide } = props;
  return (
    <div
      style={{
        display: hide ? "none" : "block",
        alignItems: "center",
        color: selected ? "#1890FF" : "gray",
        marginLeft: 20,
        marginRight: 20,
        opacity: selected ? 1 : 0.5,
        cursor: "pointer",
      }}
      onClick={setSelected}
    >
      <div style={{ marginLeft: 10, marginRight: 10 }}>
        <div
          style={{
            fontSize: 15,
            textAlign: "center",
            marginBottom: 2,
            fontWeight: selected ? 700 : 400,
          }}
        >
          {title}
        </div>
      </div>
      {selected && (
        <hr
          style={{
            backgroundColor: "#1890FF",
            border: "1px solid #1890FF",
            height: 1,
          }}
        />
      )}
    </div>
  );
};

export default Tab;
